/**
 * Ring Strategy class
 */
export default class {
  constructor (data) {
    this.id = ~~data.id
    this.name = data.name
    this.strategy = data.strategy
  }
}
